import request, { CommonListResponse, IListWorkspaceResponse, IPage, IWorkspaceResponse } from '/@/api/http/request'
const HTTP_PREFIX = '/manage/api/v1'
// 获取客户
export const getCustomerListPageVo = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/customer/getCustomerListPageVo`
  const result = await request.post(url, body)
  return result.data
}
// 添加客户
export const addCustomer = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/customer/addCustomer`
  const result = await request.post(url, body)
  return result.data
}
// 编辑客户
export const updateCustomer = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/customer/updateCustomer`
  const result = await request.post(url, body)
  return result.data
}
// 删除客户
export const deleteCustomerById = async function (id:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/customer/deleteCustomerById/${id}`
  const result = await request.get(url)
  return result.data
}
